import type { Database } from 'sql.js';
import { queryOne } from '@core/infrastructure/driven/sqljs/sqljsSqlitePrimitives.ts';

/** Silently rolls back the current database transaction. */
function rollbackQuiet(db: Database): void {
  try {
    db.run('ROLLBACK');
  } catch {
    /* ignore */
  }
}

export function deleteUploadedRedencionInDb(db: Database, schedulePersist: () => void, redencionId: number): void {
  const row = queryOne(db, 'SELECT id, offline_uploaded_at FROM redenciones_bono WHERE id = ? LIMIT 1', [redencionId]);
  if (!row) {
    throw new Error('La redención no existe.');
  }
  const uploadedRaw = row.offline_uploaded_at ?? row.OFFLINE_UPLOADED_AT;
  const uploadedStr = uploadedRaw != null && uploadedRaw !== '' ? String(uploadedRaw).trim() : '';
  if (uploadedStr.length === 0) {
    throw new Error('Solo puede eliminar registros ya enviados al servidor.');
  }
  db.run('BEGIN IMMEDIATE');
  try {
    db.run('DELETE FROM redenciones_bono WHERE id = ?', [redencionId]);
    db.run('COMMIT');
    schedulePersist();
  } catch (e) {
    rollbackQuiet(db);
    throw e;
  }
}
